module.exports = __webpack_public_path__ + "static/media/customer-service.3f39ebb7.svg";